export const createBreadcrumbSlice = (set) => ({
    breadcrumbs: [],
    setBreadcrumbs: (breadcrumbArray) => {
        set({ breadcrumbs: breadcrumbArray })
    }
})